<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{ pageTitle }}</div>
                </div>

                <div class="forms-container approval-form-shell">
                    <div v-if="successMessage" class="approval-alert approval-alert-success">
                        {{ successMessage }}
                    </div>
                    <div v-if="errorMessage" class="approval-alert approval-alert-error">
                        {{ errorMessage }}
                    </div>

                    <div v-if="alreadyHandledMessage" class="approval-alert approval-alert-neutral">
                        {{ alreadyHandledMessage }}
                    </div>

                    <div v-if="!isLoading && !errorMessage && !isSubmitted">
                        <p class="approval-helper-text">
                            Enter your name and choose whether to approve or reject this request.
                        </p>

                        <form v-on:submit.prevent>
                            <div class="row approval-form-grid">
                                <div class="col-12 col-md-6 approval-field">
                                    <label for="ActionedBy">Your Name <span>*</span></label>
                                    <select id="ActionedBy" v-model="form.ActionedBy" class="form-control" tabindex="1" v-on:keydown.enter.prevent>
                                        <option value="">Select your name</option>
                                        <option v-for="name in approverOptions" :key="name" :value="name">{{ name }}</option>
                                    </select>
                                    <div class="help is-danger">{{ fieldError('ActionedBy') }}</div>
                                </div>
                            </div>

                            <div class="approval-actions">
                                <button type="button" class="ml-2 btn btn-danger pull-right themebutton" tabindex="3" v-on:click="submitDecision('REJECTED')" :disabled="isSubmitting">
                                    <span>{{ pendingAction === 'REJECTED' ? 'Rejecting...' : 'Reject' }}</span>
                                </button>
                                <button type="button" class="ml-2 btn btn-success pull-right themebutton" tabindex="2" v-on:click="submitDecision('APPROVED')" :disabled="isSubmitting">
                                    <span>{{ pendingAction === 'APPROVED' ? 'Approving...' : 'Approve' }}</span>
                                </button>
                            </div>
                        </form>
                    </div>

                    <div v-if="isLoading" class="approval-helper-text">
                        Loading request details...
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../../http-common.js';

    export default {
        name: 'FormApprovalReview',
        data() {
            return {
                form: {
                    ActionedBy: '',
                },
                errors: {},
                errorMessage: '',
                successMessage: '',
                alreadyHandledMessage: '',
                isLoading: false,
                isSubmitting: false,
                isSubmitted: false,
                approverOptions: [],
                // Which of the two buttons was clicked, so only that one shows
                // "Processing..." while both stay disabled during the request.
                pendingAction: '',
            };
        },
        computed: {
            pageTitle() {
                return this.formTitle() + ' Review';
            },
            formType() {
                return this.$route.query.type || '';
            },
            token() {
                return this.$route.query.token || '';
            },
        },
        mounted() {
            if (!this.formType || !this.token) {
                this.errorMessage = 'Missing approval link information.';
                return;
            }

            this.loadStatus();
            this.loadApprovers();
        },
        methods: {
            formTitle() {
                if (this.formType === 'low-gp-forms') {
                    return 'Low GP Form';
                }

                if (this.formType === 'deposit-adjustment-forms') {
                    return 'Deposit Adjustment Form';
                }

                if (this.formType === 'stock-build-request-forms') {
                    return 'Stock Build Request Form';
                }

                return 'Approval';
            },
            loadApprovers() {
                var self = this;

                HTTP.get('/approval-form-approvers?type=' + encodeURIComponent(self.formType), {
                    headers: {
                        Accept: 'application/json',
                    },
                }).then(function (response) {
                    self.approverOptions = (response.data && response.data.data) || [];
                }).catch(function () {
                    self.errorMessage = 'Unable to load the approver list. Please refresh the page and try again.';
                });
            },
            fieldError(field) {
                return this.errors[field] ? this.errors[field][0] : '';
            },
            loadStatus() {
                var self = this;
                self.isLoading = true;

                HTTP.get('/' + self.formType + '/review/' + self.token, {
                    headers: {
                        Accept: 'application/json',
                    },
                }).then(function (response) {
                    if (response.data && response.data.success === false) {
                        self.errorMessage = response.data.message || 'Unable to load approval details.';
                        return;
                    }

                    if (response.data && response.data.data) {
                        self.alreadyHandledMessage = '';
                        self.form.ActionedBy = response.data.data.ActionedBy || '';
                        if (response.data.data.Status && response.data.data.Status !== 'PENDING') {
                            self.alreadyHandledMessage = 'This request has already been ' + String(response.data.data.Status).toLowerCase() + ' by ' + (response.data.data.ActionedBy || 'N/A') + '.';
                            self.isSubmitted = true;
                        }
                    }
                }).catch(function (err) {
                    if (err.response && err.response.status === 409 && err.response.data) {
                        self.alreadyHandledMessage = err.response.data.message || 'This request has already been processed.';
                        self.isSubmitted = true;
                        return;
                    }

                    if (err.response && err.response.data && err.response.data.message) {
                        self.errorMessage = err.response.data.message;
                    } else {
                        self.errorMessage = 'Unable to load approval details.';
                    }
                }).then(function () {
                    self.isLoading = false;
                });
            },
            apiEndpoint(action) {
                return '/' + this.formType + '/review/' + this.token;
            },
            submitDecision(action) {
                var self = this;
                action = action || 'APPROVED';

                self.errors = {};
                self.errorMessage = '';
                self.successMessage = '';

                if (!self.form.ActionedBy) {
                    self.errors = {
                        ActionedBy: ['This field is required.'],
                    };
                    return;
                }

                self.isSubmitting = true;
                self.pendingAction = action;

                HTTP.post(self.apiEndpoint(action), {
                    ActionedBy: self.form.ActionedBy,
                    action: action,
                }).then(function (response) {
                    self.successMessage = (response.data && response.data.message) ? response.data.message : 'Request processed successfully.';
                    self.isSubmitted = true;
                    self.alreadyHandledMessage = '';
                }).catch(function (err) {
                    if (err.response && err.response.data && err.response.data.errors) {
                        self.errors = err.response.data.errors;
                        self.errorMessage = err.response.data.message || 'Please review the highlighted fields.';
                    } else if (err.response && err.response.data && err.response.data.message) {
                        self.errorMessage = err.response.data.message;
                    } else {
                        self.errorMessage = 'Unable to process the request. Please try again.';
                    }
                }).then(function () {
                    self.isSubmitting = false;
                    self.pendingAction = '';
                });
            },
        },
    };
</script>

<style scoped>
    .approval-form-shell {
        background: #ffffff;
        border: 1px solid #d8e0e6;
        border-radius: 6px;
        box-shadow: 0 4px 16px rgba(31, 45, 61, 0.08);
        margin-top: 24px;
        padding: 34px 36px 28px;
    }

    .approval-form-grid {
        margin-left: -14px;
        margin-right: -14px;
    }

    .approval-field {
        margin-bottom: 22px;
        padding-left: 14px;
        padding-right: 14px;
    }

    .approval-field label {
        color: #2f3337;
        display: block;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .approval-field label span {
        color: #d22f2f;
    }

    .approval-actions {
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 6px;
    }

    /* button.themebutton paints every themed button blue, so the decision
       buttons need a more specific selector to keep their own colours. */
    .approval-actions button.btn-success {
        background: #28a745;
        border-bottom: 2px solid #1e7e34;
    }

    .approval-actions button.btn-success:hover:not(:disabled) {
        background: #1e7e34;
        border-bottom: 2px solid #155724;
    }

    .approval-actions button.btn-danger {
        background: #dc3545;
        border-bottom: 2px solid #b02a37;
    }

    .approval-actions button.btn-danger:hover:not(:disabled) {
        background: #b02a37;
        border-bottom: 2px solid #721c24;
    }

    .approval-actions button:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }

    .approval-helper-text {
        color: #4d5966;
        margin-bottom: 18px;
    }

    .approval-form-shell .form-control {
        min-height: 42px;
    }

    .approval-alert {
        border-radius: 4px;
        font-size: 14px;
        margin-bottom: 18px;
        padding: 12px 14px;
    }

    .approval-alert-success {
        background: #edf8f0;
        border: 1px solid #b9e4c4;
        color: #246b35;
    }

    .approval-alert-neutral {
        background: #f4f6f8;
        border: 1px solid #d7dde3;
        color: #44515f;
    }

    .approval-alert-error {
        background: #fff1f1;
        border: 1px solid #f0baba;
        color: #9d2525;
    }

    @media (max-width: 767px) {
        .approval-form-shell {
            margin-top: 18px;
            padding: 22px 18px 20px;
        }

        .approval-form-grid {
            margin-left: -8px;
            margin-right: -8px;
        }

        .approval-field,
        .approval-actions {
            padding-left: 8px;
            padding-right: 8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalForms/FormApprovalReview.vue